<template>
  <div
    id="push_loading"
    ref="loading"
    v-show="loading"
    v-loading="loading"
  ></div>
</template>

<script>
export default {
  name: "push_loading",
  data() {
    return {
      loading: false
    };
  },
  mounted() {},
  methods: {
    show() {
      this.loading = true;
    },
    hide() {
      this.loading = false;
    }
  }
};
</script>
<style scoped>
#push_loading {
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  top: 0;
  z-index: 999;
  height: 100vh;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/loading/loading.vue